'use client';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { cn } from '@/lib/utils';

import VillageCard from '../VillageCard';
import { Village } from '@/services/types';

import { VillageCardDictonary } from '../VillageCard/Root';
import useLocalStorage from '@/hooks/useLocalStorage';
import { WishList } from '../VillageCard/Options';

// Opens from the card's gallery icon: react-slick and the modal load on that click
const VillageGallery = dynamic(() => import('../VillageGallery'), {
  ssr: false,
});

type Props = {
  villages: Village[];
  showMap: boolean;
  isLoadingWithMap?: boolean;
  dicts: VillageCardDictonary;
  currency?: string;
};

export default function VillagesList({
  showMap,
  villages,
  isLoadingWithMap = false,
  dicts,
  currency,
}: Props) {
  const [villageInfo, setVillageInfo] = useState<Village>();
  const [wishList, setWishList] = useLocalStorage('villas', [] as WishList[]);

  if (villages.length === 0) {
    return (
      <div
        className={cn('grid grid-cols-1 tablet:grid-cols-3 gap-x-6 flex-1', {
          'tablet:grid-cols-1': showMap,
        })}>
        {dicts.villageDict.noResultsFound}
      </div>
    );
  }

  if (isLoadingWithMap) {
    return (
      <div
        className={cn('flex flex-wrap md:mx-[-0.9375rem]', {
          'desktop:w-[33.33333%] flex-[0_0_auto]': showMap,
        })}>
        {Array.from(Array(3).keys()).map((i) => (
          <VillageCard.Loader displayingMap key={i} />
        ))}
      </div>
    );
  }

  return (
    <div
      id="village-list-container"
      className={cn('grid grid-cols-1 tablet:grid-cols-3 gap-x-6 flex-1', {
        'tablet:grid-cols-1': showMap,
      })}>
      {villages.map((village, index) => {
        return (
          <VillageCard.Root
            dicts={dicts}
            key={index}
            infos={village}
            displayingMap={showMap}
            customCurrency={currency}
            isFirst={index === 0}>
            <VillageCard.Options
              wishList={wishList}
              setWishList={setWishList}
              onGalleryClick={setVillageInfo}
              village={village}
            />
          </VillageCard.Root>
        );
      })}

      {villageInfo && (
        <VillageGallery
          village={villageInfo}
          handleClose={() => setVillageInfo(undefined)}
          dicts={dicts}
        />
      )}
    </div>
  );
}

// unused anymore, left just in case
// function Loader() {
//   return (
//     <div className="w-full flex items-center justify-center py-12">
//       <svg
//         viewBox="0 0 24 24"
//         className="w-12 h-[3rem]"
//         xmlns="http://www.w3.org/2000/svg">
//         <circle fill="#ebbf20" cx="12" cy="12" r="0">
//           <animate
//             attributeName="r"
//             calcMode="spline"
//             dur="1.2s"
//             values="0;11"
//             keySplines=".52,.6,.25,.99"
//             repeatCount="indefinite"
//           />
//           <animate
//             attributeName="opacity"
//             calcMode="spline"
//             dur="1.2s"
//             values="1;0"
//             keySplines=".52,.6,.25,.99"
//             repeatCount="indefinite"
//           />
//         </circle>
//       </svg>
//     </div>
//   );
// }
